export enum DataTags {
    Agreements = 'Agreements',
    GetGroups = 'GetGroups',
    GetGroup = 'GetGroup',
    GetModels = 'GetModels',
    GetModel = 'GetModel',
    GetModelDriftReport = 'GetModelDriftReport',
    GetAccounts = 'GetAccounts',
    GetWatchlists = 'GetWatchlists',
    GetOrphanedAccounts = 'GetOrphanedAccounts',
    GetAccountAcats = 'GetAccountAcats',
    GetBankLinks = 'GetBankLinks',
    GetMoneyTransfers = 'GetMoneyTransfers',
    GetAccountDriftReport = 'GetAccountDriftReport',
    GetAccountOrders = 'GetAccountOrders',
    GetNotes = 'GetNotes',
    GetAllAccountsNotes = 'GetAllAccountsNotes',
    GetBranchAccount = 'GetBranchAccount',
    GetAccountBuyingPower = 'GetAccountBuyingPower',
    GetAccountPortfolio = 'GetAccountPortfolio',
    GetAccountAvailableCashForWithdrawal = 'GetAccountAvailableCashForWithdrawal',
    GetCrmProfile = 'GetCrmProfile',
    GetCrmChangesHistory = 'GetCrmChangesHistory',
    GetPhotos = 'GetPhotos',
    GetClientReminders = 'GetClientReminders',
    GetClientDocuments = 'GetClientDocuments',
    GetUmaUserInfo = 'GetUmaUserInfo',
    GetUmaUserAuthApps = 'GetUmaUserAuthApps',
    GetOrderDetails = 'GetOrderDetails',
}
